$(function () {
  // Toggle open/close
  $(document).on("click", "[data-disclosure-toggle]", function (e) {
    e.preventDefault();
    var $disclosure = $(this).closest(".disclosure");
    var $list = $disclosure.find("[data-disclosure-list]");

    $(".disclosure").not($disclosure).removeClass("is-open")
      .find("[data-disclosure-list]").hide()
      .end().find("[data-disclosure-toggle]").attr("aria-expanded", "false");

    var open = $disclosure.hasClass("is-open");
    $disclosure.toggleClass("is-open", !open);
    $(this).attr("aria-expanded", !open);
    $list.toggle(!open);
  });

  // Select option -> update UI + POST to /localization
  $(document).on("click", "[data-disclosure-option]", function (e) {
    e.preventDefault();
    var $opt = $(this);
    var $disclosure = $opt.closest(".disclosure");
    var $btn = $disclosure.find("[data-disclosure-toggle]");
    var $input = $disclosure.find("[data-disclosure-input]");
    var $list = $disclosure.find("[data-disclosure-list]");
    var country = ($opt.data("value") || "").toString().trim(); // e.g. "US", "AU"

    if (!country) return;

    // Update UI
    var newLabel = $opt.find(".disclosure-list__label").text().trim();
    $btn.find(".disclosure-list__label").text(newLabel);
    $disclosure.find(".disclosure-list__item--current")
      .removeClass("disclosure-list__item--current")
      .find("[aria-current]").removeAttr("aria-current");
    $opt.attr("aria-current", "true").closest("li").addClass("disclosure-list__item--current");

    // Hidden input (if theme uses a form)
    if ($input.length) $input.val(country).trigger("change");

    // 1) If wrapped in a <form action="/localization">, submit it.
    var $form = $disclosure.closest("form");
    if ($form.length && ($form.attr("action") || "").includes("/localization")) {
      // Ensure required fields exist
      if (!$form.find('input[name="form_type"]').length) {
        $('<input type="hidden" name="form_type" value="localization">').appendTo($form);
      }
      if (!$form.find('input[name="country_code"]').length) {
        $('<input type="hidden" name="country_code">').val(country).appendTo($form);
      } else {
        $form.find('input[name="country_code"]').val(country);
      }
      $form.trigger("submit");
      return; // stop; page will navigate
    }

    // 2) Fallback: POST via fetch to /localization, then reload.
    var fd = new FormData();
    fd.append("form_type", "localization");
    fd.append("country_code", country);

    fetch("/localization", { method: "POST", body: fd, credentials: "same-origin" })
      .then(() => window.location.reload())
      .catch(() => window.location.reload()); // still reload to reflect change

    // Close menu
    $disclosure.removeClass("is-open");
    $btn.attr("aria-expanded", "false");
    $list.hide();
  });

  // Click outside closes
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".disclosure").length) {
      $(".disclosure").removeClass("is-open")
        .find("[data-disclosure-list]").hide()
        .end().find("[data-disclosure-toggle]").attr("aria-expanded", "false");
    }
  });

  // Start hidden
  $("[data-disclosure-list]").hide();
});